import { ValidatorFn, AbstractControl } from '@angular/forms';

export function zipCode(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if(control.value) {
      const regex = /^[A-Za-z0-9\-]+$/;
      const isValid = regex.test(control.value);
      return isValid ? null : { invalidZipCode: true };
    } else {
      return null;
    }
  };
}